import axios from "axios";
import { SERVER_URL } from "../config/env";
import { buildAxiosHeaders } from "../utils/authHeaders";
import { getAuthToken } from "../utils/authTokens";
import { tokenService } from "../services/tokenService";

axios.defaults.withCredentials = true;

// attach refresh interceptors to global axios instance
const attachReauthInterceptor = (client) => {
  // request interceptor: add auth token (sync - no proactive refresh to avoid blocking)
  client.interceptors.request.use((config) => {
    // get current token synchronously
    const token = getAuthToken();
    
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    
    return config;
  });

  // response interceptor: handle 401 errors with reactive refresh
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error?.config || {};

      if (error?.response?.status !== 401) {
        return Promise.reject(error);
      }

      // prevent infinite retry loop
      if (originalRequest._retry) {
        return Promise.reject(error);
      }

      // mark as retry to prevent loop
      originalRequest._retry = true;

      // reactive refresh: try to refresh the token
      console.log("[LegacyAxios] Got 401, attempting token refresh...");
      const tokens = await tokenService.refresh();

      if (!tokens) {
        console.log("[LegacyAxios] Token refresh failed, request will fail");
        return Promise.reject(error);
      }

      // retry with new token
      console.log("[LegacyAxios] Retrying request with new token...");
      const updatedToken = getAuthToken();
      if (updatedToken) {
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${updatedToken}`,
        };
      }

      return client(originalRequest);
    }
  );
};

// attach interceptors to global axios instance
attachReauthInterceptor(axios);

export const url = SERVER_URL;

export const setHeaders = (extraHeaders) => buildAxiosHeaders(extraHeaders);
